export const currencies = [
  { title: "USD", value: "USD" as const },
  { title: "EUR", value: "EUR" as const },
  { title: "AUD", value: "AUD" as const },
  { title: "GBP", value: "GBP" as const },
  { title: "CAD", value: "CAD" as const }
];

export type Currency = (typeof currencies)[number]["value"];
